import { render, staticRenderFns } from "./PixTest.vue?vue&type=template&id=0206e2bf&scoped=true&"
import script from "./PixTest.vue?vue&type=script&lang=js&"
export * from "./PixTest.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/util.css?vue&type=style&index=0&id=0206e2bf&scoped=true&lang=css&"
import style1 from "./PixTest.vue?vue&type=style&index=1&lang=css&"
import style2 from "./PixTest.vue?vue&type=style&index=2&id=0206e2bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206e2bf",
  null
  
)

export default component.exports